import productViewInstallmentsHtml from './productviewinstallments.component.html';
import './productviewinstallments.component.scss';

class ProductViewInstallmentsController {
    constructor($scope, $http, $interval, $location, ProductViewService, ModalService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.$interval = $interval;
        this.$location = $location;
        this.ProductViewService = ProductViewService;
        this.ModalService = ModalService;

        this.init = false;

        this.santanderPartnerId = null;
        this.santanderPartnerIdUnderFiveThousand = null;
        this.caPosId = '';

        this.leaseLinkButton = null;
        this.leaseLinkReady = false;

        this.activeTab = 'installments';

        this.currentUrl = null;
        this.productInfoHelper = null;
    }

    $onInit() {
        this.currentUrl = this.$location.absUrl().split('#')[0];

        this.productInfoHelper = productInfoHelper;

        this.$scope.$watch(() => this.ProductViewService.variant, (newVariant, oldVariant) => {
            if (oldVariant && oldVariant.id === newVariant.id) {
                return;
            }

            this.updateLeaseLinkCalculator();
        }, true);

        this.$scope.$watch(() => this.ProductViewService.price, (newPrice, oldPrice) => {
            const installmentsMenuitems = document.getElementsByClassName('installments-menuitem');
            if (this.displayInstallments) {
                Array.from(installmentsMenuitems).forEach(installmentsMenuitem => installmentsMenuitem.classList.remove('d-none'));
            } else {
                Array.from(installmentsMenuitems).forEach(installmentsMenuitem => installmentsMenuitem.classList.add('d-none'));
            }
        }, true);

        const checkLeaseLinkButtonInterval = this.$interval(
            () => {
                this.leaseLinkButton = document.querySelector('.btn-leaselink');
                if (this.leaseLinkButton) {
                    this.leaseLinkReady = true;
                    this.$interval.cancel(checkLeaseLinkButtonInterval);
                }
            }, 250, 20);
    }

    openLeaseLinkCalculator() {
        const llBtn = document.querySelector('.LLBCn > a');
        if (llBtn) {
            llBtn.click();
        }
    }

    updateLeaseLinkCalculator() {
        // Refresh the LeaseLink button
        document.querySelector('.variants-container').click();
    }

    openEmbeddedCalculator(url, title) {
        const frame = document.createElement('iframe');
        frame.src = url;
        frame.title = title;
        frame.className = 'installment-calculator-frame';
        const modal = this.ModalService.add(title, frame, () => { frame.src = 'about:blank'; }, true, null, 'modal-calculator');
        modal.open();
    }

    openSantanderCalculator() {
        const santanderPartnerId = this.ProductViewService.price.price_gros > 5000 ? this.santanderPartnerId : this.santanderPartnerIdUnderFiveThousand;

        const santanderCalculatorUrl = 'https://wniosek.eraty.pl/symulator/oblicz/numerSklepu/'
            + santanderPartnerId + '/wariantSklepu/1/typProduktu/0/wartoscTowarow/'
            + this.ProductViewService.price.price_gros;

        this.openEmbeddedCalculator(santanderCalculatorUrl, 'Kalkulator rat Santander Consumer Bank');
    }

    openPkoLeasingCalculator() {
        document.querySelector('pkol-installment-widget .widget-pko').click();
    }

    openCaCalculator() {
        const caCalculatorUrl = 'https://ewniosek.credit-agricole.pl/eWniosek/simulator.jsp?PARAM_TYPE=RAT' +
            '&PARAM_PROFILE=' + this.caPosId +
            '&PARAM_CREDIT_AMOUNT=' + this.ProductViewService.price.price_gros;

        window.open(caCalculatorUrl, 'installment_ca', 'width=620, height=520, directories=no, location=no, menubar=no, resizable=yes, scrollbars=yes, status=no, toolbar=no');
    }

    openPayuCalculator() {
        this.openEmbeddedCalculator('/payu/' + this.ProductViewService.price.price_gros.toString().replace('.', ','), 'Kalkulator rat PayU');
    }

    openIngLeaseNowLeasingCalculator() {
        window.open('https://leasenow.pl/klient', '_blank');
    }

    openSantanderLeasingCalculator() {
        window.open('santander', 'leasing_santander', 'width=800, height=535, directories=no, location=no, menubar=no, resizable=yes, scrollbars=yes, status=no, toolbar=no');
    }

    showHowToBuyDescription() {
        const modalRef = this.ModalService.add(
            'Jak kupić na <span class="text-primary">e-raty</span>',
            this.howToBuy,
            null,
            true,
            'frame-size-modal',
            'modal-lg modal-installments'
        );

        modalRef.open();
    }

    get displayInstallments() {
        return this.ProductViewService && this.ProductViewService.price && this.ProductViewService.price.price_gros >= 300;
    }
}

let productViewInstallmentsComponent = {
    bindings: {
        santanderPartnerId: '@',
        santanderPartnerIdUnderFiveThousand: '@',
        caPosId: '@',
        howToBuy: '<'
    },
    template: productViewInstallmentsHtml,
    controller: ProductViewInstallmentsController
}

export default productViewInstallmentsComponent;
